import { AxiosPromise } from 'axios';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { HttpResponse } from 'shell/models/http-response';
import { Subscriber } from 'shell/models/subscriber';
import SubscriberFormComponent from 'system/components/subscriber/form';
import { subscriberCrumbs } from '../constants';
import { transformSubscriber } from '../utils/transform-subscriber';
import { transformSubsciberResponse } from '../utils/transform-subscriber';
import { transformRequestSubscriber } from '../utils/transform-subscriber-request';

const SubscriberEditPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/sottoscrittore');
  };

  const params = useParams();

  const [subscriber] = useHttpFetch<HttpResponse<Subscriber>, transformSubsciberResponse>(
    `${__OPERATION__EVENT__ADMIN__}/sottoscrittore/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformSubscriber,
    }
  );

  const updateSottoscittore = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/sottoscrittore`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback((formValues) => {
    const updateData = transformRequestSubscriber(formValues);
    (
      updateSottoscittore({
        data: updateData,
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/sottoscrittore');
    });
  }, []);

  return (
    <>
      <Breadcrumbs items={[...subscriberCrumbs, { name: 'Modifica Sottoscrittore' }]} />
      <SubscriberFormComponent
        forminitialValues={subscriber.data as transformSubsciberResponse}
        onOk={onSubmit}
        title="Modifica"
        onCancel={onCancel}
        isEdit
      />
    </>
  );
};

SubscriberEditPage.displayName = 'Subscriber Detail Page';
export default SubscriberEditPage;
